import { RiTestTubeLine } from "@onemind-services-llc/react-icons-ng/ri";
import {
  MdOutlineCloudDone,
  MdOutlineIntegrationInstructions,
  MdOutlineSupportAgent,
} from "@onemind-services-llc/react-icons-ng/md";
import { SimpleList } from "@/components/list";

export const ONEMIND_PHYSICAL_LABS_CONSTANTS = {
  title: "Benefits of Physical Labs for SI, VAR, and COE",
  desc: "Physical Labs serve as innovation hubs for IT professionals and organizations, enabling solution validation, accelerated deployments, and continuous learning.",
  list: [
    {
      icon: RiTestTubeLine,
      title: "Solution Validation & Deployment",
      content: (
        <SimpleList
          points={[
            "Thorough testing ensures products meet client requirements and integrate seamlessly.",
            "Pre-tested solutions enable faster, risk-free deployment with reduced implementation risks.",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineCloudDone,
      title: "Improved Customer Trust & Credibility",
      content: (
        <SimpleList
          points={[
            "Demonstrating solutions in action builds confidence and reassures clients of their value.",
            "Reliable performance proves product effectiveness in real-world scenarios.",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineSupportAgent,
      title: "Innovation & Competitive Edge",
      content: (
        <SimpleList
          points={[
            "Ongoing learning & development keeps teams updated on the latest technologies.",
            "A dedicated innovation space helps organizations stay ahead of industry trends.",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineIntegrationInstructions,
      title: "Reliable Implementation & Business Growth",
      content: (
        <SimpleList
          points={[
            "Risk reduction strategies ensure smooth transitions and seamless adoption.",
            "Market-driven solutions provide long-term business value.",
          ]}
        />
      ),
    },
  ],
};
